import _ from "underscore";
import { Tag } from "./tag";

// eslint-disable-next-line no-shadow
export enum LibraryObjectType {
  COURSE = "course",
  LESSON = "lesson",
  FOLDER = "folder",
}

export class LibraryObject {
  id: string = "";
  key: string = "";
  name: string = "";
  description?: string;
  preview_url?: string;
  preview_vertical_url?: string;
  preview_horizontal_url?: string;
  preview?: File;
  preview_vertical?: File;
  preview_horizontal?: File;
  author?: string;
  order?: number;
  parent?: LibraryObject | ParentId;
  length?: number;
  subtype?: string;
  readings?: number;
  videos?: number;
  tags?: Tag[];
  type?: LibraryObjectType;
  icon_url?: string;
  tier?: string;

  clone(): LibraryObject {
    const object = new LibraryObject();
    object.id = this.id;
    object.key = this.key;
    object.name = this.name;
    object.description = this.description;
    object.preview_url = this.preview_url;
    object.preview_vertical_url = this.preview_vertical_url;
    object.preview_horizontal_url = this.preview_horizontal_url;
    object.preview = this.preview;
    object.preview_vertical = this.preview_vertical;
    object.preview_horizontal = this.preview_horizontal;
    object.author = this.author;
    object.order = this.order;
    object.parent =
      this.parent && this.parent instanceof LibraryObject
        ? this.parent.clone()
        : _.clone(this.parent);
    object.length = this.length;
    object.subtype = this.subtype;
    object.readings = this.readings;
    object.videos = this.videos;
    object.type = this.type;
    object.icon_url = this.icon_url;
    object.tier = this.tier;

    return object;
  }
}

interface EditorHierarchy {
  id: string;
  name: string;
  type: "object" | "version";
  editor_hierarchy: EditorHierarchy | null;
}

export type AdminLibraryObject = LibraryObject & { editor_hierarchy: EditorHierarchy };

export class ParentId {
  id: string = "";
}

export interface LibraryVersion {
  id: string;
  key: string;
  name: string;
  description?: string;
  preview_url?: string;
  preview_vertical_url?: string;
  preview_horizontal_url?: string;
  preview?: File;
  preview_vertical?: File;
  preview_horizontal?: File;
  author?: string;
  order?: number;
  editor_hierarchy: EditorHierarchy;
  length?: number;
  subtype?: string;
  readings?: number;
  videos?: number;
  type: LibraryObjectType;
  tags: Tag[];
  original?: { id: string };
  icon_url?: string;
  tier?: string;
}

export interface CreateLibraryVersionRequest {
  name: string;
  description?: string;
  preview_url?: string;
  preview_vertical_url?: string;
  preview_horizontal_url?: string;
  preview?: File;
  preview_vertical?: File;
  preview_horizontal?: File;
  author?: string;
  order?: number;
  length?: number;
  subtype?: string;
  readings?: number;
  videos?: number;
  type: LibraryObjectType;
  original_id?: string;
  original_version_id?: string;
  keep_original_link?: boolean;
  hidden?: boolean;
  parent_library_object_id: string | null;
}

export interface LibraryDraftSpaceResponse {
  library_objects: AdminLibraryObject[];
  library_versions: LibraryVersion[];
  parent_library_object?: AdminLibraryObject;
  parent_library_version?: LibraryVersion;
}

export interface UploadLibraryResourceResponse {
  list: { name: string; upload_url: string }[];
}
